




















































































































































































































import store from '../store'
import { inputs, printPage } from '../mixins/mixins'
import { openLinkInBrowser } from '@/mla-shared'
const colwellData = require('../data/colwell-data.json')
const colwellCurve = require('../data/colwell-curve.json')
const olsenData = require('../data/olsen-data.json')
const olsenCurve = require('../data/olsen-curve.json')

export default {
  mixins: [ inputs, printPage ],

  data () {
    return {
      title: 'Step 1',
      ss: store.state,
      chartId: 'criticalValueChart',
      readMoreActivated: [false],
      update: 0
    }
  },

  computed: {
    testType: {
      get() {
        return store.state.step1.type;
      },
      set(newValue:string) {
        store.state.step1.type = newValue;
      }
    },

    currentTestValue: {
      get() {
        return store.state.step1.value;
      },
      set(this:any, newValue:number) {
        store.state.step1.value = newValue;
      }
    },

    pbi: {
      get() {
        return store.state.step1.pbi
      },
      set(this:any, newValue:number) {
        store.state.step1.pbi = newValue;
        this.updateCriticalTest(newValue);
      }
    },

    criticalTestValue: {
      get(this:any) {
        return (
          this.testType === 'Colwell'
          ? store.state.step1.colwellP
          : store.state.step1.olsenP
        )
      },
      set(this:any, newValue:number) {
        this.testType === 'Colwell'
        ? store.state.step1.colwellP = newValue as number
        : store.state.step1.olsenP = newValue as number
      }
    },

    chartData: function () {
      const colwellGraph = {
        datasets: [
          // Vertical Line (red)
          {
            type: 'line',
            label: 'Target Colwell P',
            backgroundColor: '#F44336',
            borderColor: '#F44336',
            borderWidth: 2,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            pointStyle: 'line',
            borderDash: (['4', '2']),
            data: [
              {
                x: 0,
                y: store.state.step1.colwellP
              },
              {
                x: 600,
                y: store.state.step1.colwellP
              }
            ]
          },
          // Arrow Left (red)
          {
            type: 'scatter',
            backgroundColor: '#F44336',
            borderColor: '#F44336',
            pointBackgroundColor: '#F44336',
            pointBorderColor: '#F44336',
            pointStyle: 'triangle',
            pointRadius: 5,
            rotation: 270,
            data: [
              {
                x: 3,
                y: store.state.step1.colwellP
              }
            ]
          },
          // Horizontal Line (red)
          {
            type: 'line',
            label: 'PBI',
            backgroundColor: '#F44336',
            borderColor: '#F44336',
            borderWidth: 2,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            pointStyle: 'line',
            borderDash: (['4', '2']),
            data: [
              {
                x: store.state.step1.pbi,
                y: 0
              },
              {
                x: store.state.step1.pbi,
                y: store.state.step1.colwellP
              }
            ]
          },
          // Arrow Intersection (red)
          {
            type: 'scatter',
            backgroundColor: '#F44336',
            borderColor: '#F44336',
            pointBackgroundColor: '#F44336',
            pointBorderColor: '#F44336',
            pointStyle: 'triangle',
            pointRadius: 5,
            data: [
              {
                x: store.state.step1.pbi,
                y: store.state.step1.colwellP - 1
              }
            ]
          },
          // Arrow Intersection (red)
          {
            type: 'scatter',
            backgroundColor: '#F44336',
            borderColor: '#F44336',
            pointBackgroundColor: '#F44336',
            pointBorderColor: '#F44336',
            pointStyle: 'triangle',
            pointRadius: 5,
            data: [
              {
                x: store.state.step1.pbi,
                y: 1
              }
            ]
          },
          // Curved Line (black)
          {
            type: 'line',
            label: 'Colwell P',
            backgroundColor: '#000',
            borderColor: '#000',
            borderWidth: 4,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            pointStyle: 'line',
            data: colwellCurve,
            tension: 0.3
          },
          // Horizontal Line (blue)
          {
            type: 'line',
            label: 'Current Colwell P',
            backgroundColor: '#1976d2',
            borderColor: '#1976d2',
            borderWidth: 2,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            pointStyle: 'line',
            data: [
              {
                x: 0,
                y: store.state.step1.value
              },
              {
                x: 600,
                y: store.state.step1.value
              }
            ]
          },
          // Test data
          {
            type: 'scatter',
            label: 'Test data',
            borderColor: '#800080',
            backgroundColor: 'transparent',
            showLine: false,
            data: colwellData
          }
        ]
      }
      const olsenGraph = {
        datasets: [
          // Vertical Line (Red)
          {
            type: 'line',
            label: 'Target Olsen P',
            backgroundColor: '#F44336',
            borderColor: '#F44336',
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            pointStyle: 'line',
            borderDash: (['4', '2']),
            data: [
              {
                x: store.state.step1.olsenP,
                y: 0
              },
              {
                x: store.state.step1.olsenP,
                y: 100 * (1 - Math.exp(-0.202 * store.state.step1.olsenP))
              }
            ]
          },
          // Arrow Right (red)
          {
            type: 'scatter',
            backgroundColor: '#F44336',
            borderColor: '#F44336',
            pointBackgroundColor: '#F44336',
            pointBorderColor: '#F44336',
            pointStyle: 'triangle',
            pointRadius: 5,
            rotation: 90,
            data: [
              {
                x: 0.2,
                y: 100 * (1 - Math.exp(-0.202 * store.state.step1.olsenP))
              }
            ]
          },
          // Horizontal Line (Red)
          {
            type: 'line',
            label: 'Target Yield',
            backgroundColor: '#F44336',
            borderColor: '#F44336',
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            pointStyle: 'line',
            borderDash: (['4', '2']),
            data: [
              {
                x: 0,
                y: 100 * (1 - Math.exp(-0.202 * store.state.step1.olsenP))
              },
              {
                x: store.state.step1.olsenP,
                y: 100 * (1 - Math.exp(-0.202 * store.state.step1.olsenP))
              }
            ]
          },
          // Arrow Intersection (red)
          {
            type: 'scatter',
            backgroundColor: '#F44336',
            borderColor: '#F44336',
            pointBackgroundColor: '#F44336',
            pointBorderColor: '#F44336',
            pointStyle: 'triangle',
            pointRadius: 5,
            rotation: 180,
            data: [
              {
                x: store.state.step1.olsenP,
                y: (100 * (1 - Math.exp(-0.202 * store.state.step1.olsenP))) - 1.5
              }
            ]
          },
          // Arrow Down (red)
          {
            type: 'scatter',
            backgroundColor: '#F44336',
            borderColor: '#F44336',
            pointBackgroundColor: '#F44336',
            pointBorderColor: '#F44336',
            pointStyle: 'triangle',
            pointRadius: 5,
            rotation: 180,
            data: [
              {
                x: store.state.step1.olsenP,
                y: 3
              }
            ]
          },
          // Curved Line (black)
          {
            type: 'line',
            label: 'Olsen P',
            backgroundColor: '#000',
            borderColor: '#000',
            borderWidth: 4,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            pointStyle: 'line',
            fill: false,
            data: olsenCurve,
            tension: 0.3
          },
          // Vertical Line (Blue)
          {
            type: 'line',
            label: 'Current Olsen P',
            backgroundColor: '#1976d2',
            borderColor: '#1976d2',
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            pointStyle: 'line',
            data: [
              {
                x: store.state.step1.value,
                y: 0
              },
              {
                x: store.state.step1.value,
                y: 100 * (1 - Math.exp(-0.202 * store.state.step1.value))
              }
            ]
          },
          // Horizontal Line (Blue)
          {
            type: 'line',
            label: 'Current Yield',
            backgroundColor: '#1976d2',
            borderColor: '#1976d2',
            borderWidth: 2,
            fill: false,
            pointBackgroundColor: 'transparent',
            pointBorderColor: 'transparent',
            pointStyle: 'line',
            data: [
              {
                x: 0,
                y: 100 * (1 - Math.exp(-0.202 * store.state.step1.value))
              },
              {
                x: store.state.step1.value,
                y: 100 * (1 - Math.exp(-0.202 * store.state.step1.value))
              }
            ]
          },
          // Sand
          {
            type: 'scatter',
            label: 'Sand',
            borderColor: '#FF6600',
            backgroundColor: 'transparent',
            showLine: false,
            data: olsenData.filter((od:any) => od.type === 'Sand')
          },
          // Sandy loam
          {
            type: 'scatter',
            label: 'Sandy loam',
            borderColor: '#FF0000',
            backgroundColor: 'transparent',
            showLine: false,
            data: olsenData.filter((od:any) => od.type === 'Sandy loam')
          },
          // Sandy clay loam
          {
            type: 'scatter',
            label: 'Sandy clay loam',
            borderColor: '#008000',
            backgroundColor: 'transparent',
            showLine: false,
            data: olsenData.filter((od:any) => od.type === 'Sandy clay loam')
          },
          // Clay
          {
            type: 'scatter',
            label: 'Clay',
            borderColor: '#0000FF',
            backgroundColor: 'transparent',
            showLine: false,
            data: olsenData.filter((od:any) => od.type === 'Clay')
          },
          // Clay loam
          {
            type: 'scatter',
            label: 'Clay loam',
            borderColor: '#800080',
            backgroundColor: 'transparent',
            showLine: false,
            data: olsenData.filter((od:any) => od.type === 'Clay loam')
          },
        ]
      }
      let data = store.state.step1.type === 'Colwell' ? colwellGraph : olsenGraph
      return data
    },

    chartOptions: function () {
      return {
        responsive: true,
        maintainAspectRatio: true,
        showAllTooltips: true,
        scales: {
          x: {
            type: 'linear',
            display: true,
            position: 'bottom',
            title: {
              display: true,
              text: store.state.step1.type === 'Colwell' ? 'PBI' : 'Olsen P soil test value (mg P/kg soil)',
              color: '#000',
              font: {
                size: 14
              },
              padding: {
                top: 15
              }
            },
            ticks: {
              color: '#000',
              stepSize: store.state.step1.type === 'Colwell' ? 50 : 5,   
              callback: function(val:any, index:number) {
                return index % 2 === 0 ? val : '';
              }
            },
            grid: {
              color: 'rgba(0,0,0,0.05)',
              tickColor: '#000',
              borderColor: '#000'
            }
          },
          y: {
            type: 'linear',
            display: true,
            position: 'left',
            title: {
              display: true,
              text: store.state.step1.type === 'Colwell' ? 'Critical Colwell P (mg P/kg soil)' : 'Percentage of maximum pasture yield (%)',
              color: '#000',
              font: {
                size: 14
              },
              padding: {
                bottom: 15
              }
            },
            ticks: {
              color: '#000',
              stepSize: 5,
              callback: function(val:any, index:number) {
                return index % 2 === 0 ? val + (store.state.step1.type === 'Olsen' ? '%' : '') : '';
              }
            },
            grid: {
              color: 'rgba(0,0,0,0.05)',
              tickColor: '#000',
              borderColor: '#000'
            }
          }
        },
        plugins: {
          chartCustomization: {
            borderColor: 'rgba(0,0,0,0.1)',
            borderWidth: 1
          },
          tooltip: {
            filter: function (tooltipItem:any) {
              return tooltipItem.dataset.pointStyle != 'triangle';
            },
            callbacks: {
              label: function(context:any) {
                let xLabel:string = ''
                let yLabel:string = ''
                if (context.parsed.x !== null) {
                  xLabel += parseFloat(context.parsed.x.toFixed(1));
                }
                if (context.parsed.y !== null) {
                  yLabel += parseFloat(context.parsed.y.toFixed(1));
                }
                return context.dataset.label + ': (' + xLabel + ', ' + yLabel + ')';
              },
              labelColor: function(context:any) {
                let dataset = context.chart.config.data.datasets[context.datasetIndex]
                return {
                  borderColor: dataset.backgroundColor != 'transparent' ? dataset.backgroundColor : dataset.borderColor,
                  backgroundColor: dataset.backgroundColor != 'transparent' ? dataset.backgroundColor : dataset.borderColor,
                  borderRadius: 5
                };
              },
              title: function() {
                return null
              }
            }
          },
          legend: {
            display: true,
            labels: {
              usePointStyle: true,
              boxWidth: 8,
              color: '#000',
              font: {
                size: 12
              },
              filter: function (legendItem:any) {
                return legendItem.text;
              },
              generateLabels: function(chart:any) {
                let data = chart.data;
                let legends = Array.isArray(data.datasets) ? data.datasets.map(function(dataset:any, i:number) {
                  return {
                    text: dataset.label,
                    datasetIndex: i,
                    fillStyle: dataset.borderDash ? 'transparent' : dataset.backgroundColor,
                    hidden: !chart.isDatasetVisible(i),
                    strokeStyle: dataset.borderColor,
                    pointStyle: dataset.pointStyle,
                    lineDash: dataset.borderDash,
                    lineWidth: dataset.borderWidth ? dataset.borderWidth : 2,
                    borderRadius: dataset.type === 'scatter' ? 6 : 0,
                    rotation: (dataset.label === 'PBI' || dataset.label === 'Target Olsen P') ? 270 : 0
                  };
                }, this) : [];
                return legends;
              }
            }
          }
        }
      }
    }
  },

  methods: {
    // Calculate the Predicted critical soil test value / target
    target: function (pbi:number, type:string): number {
      let v1:number = Math.log((95 - 100) / -100);
      let v2:number = Math.exp(-0.201 * pbi);
      let v3:number = Math.pow(pbi, 0.184);
      store.state.step1.colwellP = v1 / (-0.196 + (0.045 - 0.227 * v2) * v3);
      store.state.step1.olsenP = 15
      let target = type === 'Colwell' ? store.state.step1.colwellP : store.state.step1.olsenP
      return target
    },

    // Change test value type between 'alternative' and 'predicted'
    changeTestValueType: function (this:any) {
      store.state.step1.alt = !store.state.step1.alt
      if (store.state.step1.alt === false) {
        this.target(store.state.step1.pbi, store.state.step1.type)
      }
      this.update += 1
    },

    // Update critical test value
    updateCriticalTest(this:any, newValue:number) {
      if (!store.state.step1.alt) {
        this.criticalTestValue = this.target(newValue, this.testType)
      }
    },

    // Read more toggle
    activateReadMore: function (this:any, index:number) {
      this.readMoreActivated.splice(index, 1, !this.readMoreActivated[index])
    },

    // Open eLearning
    async openElearning (e: any) {
      e.preventDefault();
      openLinkInBrowser('https://elearning.mla.com.au/');
    }
  },

  store
}
